<template>
  <div>
    <el-table
      :border="true"
      :data="rows"
      @sort-change="doChangeSort"
      ref="table"
      row-key="id"
      v-loading="loading"
    >
      <el-table-column type="selection" width="55"></el-table-column>

      <el-table-column v-if="hasPermissionToAuditLogs" :label="fields.id.label"  :prop="fields.id.name" sortable="custom">
        <template slot-scope="scope">{{ presenter(scope.row, 'id') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.title.label"
        :prop="fields.title.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'title') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.subtitle.label"
        :prop="fields.subtitle.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'subtitle') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.contentHtml.label"
        :prop="fields.contentHtml.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'contentHtml') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.description.label"
        :prop="fields.description.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'description') }}</template>
      </el-table-column>

      <el-table-column :label="fields.media.label" :prop="fields.media.name" align="center">
        <template slot-scope="scope">
          <app-list-item-file :value="presenter(scope.row, 'media')"></app-list-item-file>
        </template>
      </el-table-column>

      <el-table-column
        :label="fields.status.label"
        :prop="fields.status.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'status') }}</template>
      </el-table-column>

      <el-table-column :label="fields.propertyOwner.label" :prop="fields.propertyOwner.name">
        <template slot-scope="scope">
          <app-list-item-relation-to-one
            :label="fields.propertyOwner.label"
            :permission="fields.propertyOwner.readPermission"
            :url="fields.propertyOwner.viewUrl"
            :value="presenter(scope.row, 'propertyOwner')"
          ></app-list-item-relation-to-one>
        </template>
      </el-table-column>

      <el-table-column
        :label="fields.createdAt.label"
        :prop="fields.createdAt.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'createdAt') }}</template>
      </el-table-column>

      <el-table-column :fixed="isMobile? undefined : 'right'" align="center" width="180">
        <template slot-scope="scope">
          <div class="table-actions">
            <router-link :to="`/news/${scope.row.id}`">
              <el-button type="text">
                <app-i18n code="common.view"></app-i18n>
              </el-button>
            </router-link>

            <router-link :to="`/news/${scope.row.id}/edit`" v-if="hasPermissionToEdit">
              <el-button type="text">
                <app-i18n code="common.edit"></app-i18n>
              </el-button>
            </router-link>

            <el-button
              :disabled="destroyLoading"
              @click="doDestroyWithConfirm(scope.row.id)"
              type="text"
              v-if="hasPermissionToDestroy"
            >
              <app-i18n code="common.destroy"></app-i18n>
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="el-pagination-wrapper">
      <el-pagination
        :current-page="pagination.currentPage || 1"
        :disabled="loading"
        :layout="paginationLayout"
        :total="count"
        @current-change="doChangePaginationCurrentPage"
        @size-change="doChangePaginationPageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { NewsModel } from '@modules/news/news-model';
import { mapGetters, mapActions } from 'vuex';
import { NewsPermissions } from '@modules/news/news-permissions';
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { i18n } from '@shared/i18n';

const { fields } = NewsModel;

export default {
  name: 'app-news-list-table',

  mounted() {
    this.doMountTable(this.$refs.table);
  },

  computed: {
    ...mapGetters({
      rows: 'news/list/rows',
      count: 'news/list/count',
      loading: 'news/list/loading',
      pagination: 'news/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'news/destroy/loading',
      paginationLayout: 'layout/paginationLayout',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new NewsPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new NewsPermissions(this.currentUser).destroy;
    },

    fields() {
      return fields;
    },
  },

  methods: {
    ...mapActions({
      doChangeSort: 'news/list/doChangeSort',
      doChangePaginationCurrentPage:
        'news/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'news/list/doChangePaginationPageSize',
      doMountTable: 'news/list/doMountTable',
      doDestroy: 'news/destroy/doDestroy',
    }),

    presenter(row, fieldName) {
      return NewsModel.presenter(row, fieldName);
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy(id);
      } catch (error) {
        // no
      }
    },
  },
};
</script>

<style>
</style>
